// Mock data for NICE Grading application

export const pricingPlans = [
  {
    id: 1,
    title: "Standard",
    subtitle: "Up to 24 cards",
    originalPrice: 20,
    currentPrice: 16,
    description: "Perfect for individual collectors",
    features: [
      "Professional grading",
      "Museum-grade holder",
      "10-15 business days"
    ],
    isPopular: false
  },
  {
    id: 2,
    title: "Value",
    subtitle: "25+ cards",
    originalPrice: 15,
    currentPrice: 12,
    description: "Great for regular submissions",
    features: [
      "Professional grading",
      "Museum-grade holder",
      "10-15 business days",
      "Volume discount"
    ],
    isPopular: true
  },
  {
    id: 3,
    title: "Bulk",
    subtitle: "100+ cards",
    originalPrice: 12,
    currentPrice: 10,
    description: "Best value for bulk submissions",
    features: [
      "Professional grading",
      "Museum-grade holder",
      "10-15 business days",
      "Maximum savings"
    ],
    isPopular: false
  }
];

export const features = [
  {
    id: 1,
    icon: "Cpu",
    title: "Nivora Intelligence™",
    description: "Our proprietary grading technology ensures consistent, accurate evaluations of every card."
  },
  {
    id: 2,
    icon: "CircleCheck",
    title: "Zero Upcharge",
    description: "Transparent pricing with no hidden fees or surprise costs. The price you see is the price you pay."
  },
  {
    id: 3,
    icon: "Zap",
    title: "Rapid Turnaround",
    description: "Get your cards back in days not months, without sacrificing quality and accuracy."
  }
];

export const mockUser = {
  id: "user_001",
  email: "collector@example.com",
  name: "John Collector"
};

export const mockSubmissions = [
  {
    id: "SUB-001",
    status: "In Progress",
    cardCount: 5,
    totalCost: 80,
    createdAt: "2025-07-15"
  },
  {
    id: "SUB-002",
    status: "Completed",
    cardCount: 30,
    totalCost: 360,
    createdAt: "2025-07-01"
  }
];
